import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Settings from '@/views/Settings.vue';
import Player from '@/views/Player.vue';
import AgeSetting from '@/components/AgeSetting.vue';
import Folder from '@/views/Folder.vue';
import Game from '@/views/Game.vue';
import Puzzle from '@/views/Puzzle.vue';
import Search from '@/views/Search.vue';
import LoopSong from '@/utils/sounds';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/folder/:identifier',
      name: 'folder',
      component: Folder,
      props: true,
    },
    {
      path: '/game/:identifier',
      name: 'game',
      component: Game,
    },
    {
      path: '/player/:videoId',
      name: 'player',
      component: Player,
      props: true,
    },
    {
      path: '/:partner?/:action?',
      name: 'home',
      component: Home,
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
    },
    {
      path: '/age',
      name: 'age',
      component: AgeSetting,
    },
    {
      path: '/gaming/:gameType/:identifier/:position',
      name: 'gaming',
      component: Puzzle,
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
    },
  ],
});

router.beforeEach((to, from, next) => {
  localStorage.setItem('lastRouteName', from && from.name ? from.name : '');
  next();
});

router.afterEach((to, from) => {
  // Try to play on route change
  LoopSong.play();
});

export default router;
